import payment from '../api/payment';

import {
  GET_PAYMENTS_BEGIN,
  GET_PAYMENTS_SUCCESS,
  GET_PAYMENTS_FAILURE,
  GET_PROVIDER_PAYMENT_LIST_BEGIN,
  GET_PROVIDER_PAYMENT_LIST_SUCCESS,
  GET_PROVIDER_PAYMENT_LIST_FAILURE,
  GET_DEALER_PAYMENT_LIST_BEGIN,
  GET_DEALER_PAYMENT_LIST_SUCCESS,
  GET_DEALER_PAYMENT_LIST_FAILURE,
  CREATE_DEALER_PAYMENT_BEGIN,
  CREATE_DEALER_PAYMENT_SUCCESS,
  CREATE_DEALER_PAYMENT_FAILURE,
  UPDATE_DEALER_PAYMENT_BEGIN,
  UPDATE_DEALER_PAYMENT_SUCCESS,
  UPDATE_DEALER_PAYMENT_FAILURE,
  GET_SUBSCRIPTION_PAYMENT_LIST_BEGIN,
  GET_SUBSCRIPTION_PAYMENT_LIST_SUCCESS,
  GET_SUBSCRIPTION_PAYMENT_LIST_FAILURE,
  GET_REFUND_PAYMENT_LIST_BEGIN,
  GET_REFUND_PAYMENT_LIST_SUCCESS,
  GET_REFUND_PAYMENT_LIST_FAILURE,
  CREATE_PAYMENT_BEGIN,
  CREATE_PAYMENT_SUCCESS,
  CREATE_PAYMENT_FAILURE,
  CHECK_PAYMENT_BEGIN,
  CHECK_PAYMENT_SUCCESS,
  CHECK_PAYMENT_FAILURE,
  RESET_PAYMENT_ID,
} from './types';

const initialState = {
  error: false,
  paymentListError: false,
  paymentDataError: false,
  providerPaymentError: false,
  dealerPaymentError: false,
  createDealerPaymentError: false,
  updateDealerPaymentError: false,
  subscriptionPaymentError: false,
  refundPaymentError: false,
  providerPaymentList: {},
  dealerPaymentList: {},
  subscriptionPaymentList: {},
  refundPaymentList: {},
  paymentData: {},
  paymentList: {},
  paymentId: localStorage.getItem('paymentId') || '',
};

const getters = {};

const actions = {
  getPaymentList({ commit }, filter) {
    commit(GET_PAYMENTS_BEGIN);
    return payment.getPaymentList(filter)
      .then((response) => commit(GET_PAYMENTS_SUCCESS, response.data))
      .catch((error) => commit(GET_PAYMENTS_FAILURE, error.response.data));
  },
  getProviderPaymentList({ commit }, filter) {
    commit(GET_PROVIDER_PAYMENT_LIST_BEGIN);
    return payment.getProviderPaymentList(filter)
      .then((response) => commit(GET_PROVIDER_PAYMENT_LIST_SUCCESS, response.data))
      .catch((error) => commit(GET_PROVIDER_PAYMENT_LIST_FAILURE, error.response.data));
  },
  getDealerPaymentList({ commit }, filter) {
    commit(GET_DEALER_PAYMENT_LIST_BEGIN);
    return payment.getDealerPaymentList(filter)
      .then((response) => commit(GET_DEALER_PAYMENT_LIST_SUCCESS, response.data))
      .catch((error) => commit(GET_DEALER_PAYMENT_LIST_FAILURE, error.response.data));
  },
  createDealerPayment({ commit }, data) {
    commit(CREATE_DEALER_PAYMENT_BEGIN);
    return payment.createDealerPayment(data)
      .then(() => commit(CREATE_DEALER_PAYMENT_SUCCESS))
      .catch((error) => commit(CREATE_DEALER_PAYMENT_FAILURE, error.response.data));
  },
  updateDealerPayment({ commit }, { id, data }) {
    commit(UPDATE_DEALER_PAYMENT_BEGIN);
    return payment.updateDealerPayment(id, data)
      .then(() => commit(UPDATE_DEALER_PAYMENT_SUCCESS))
      .catch((error) => commit(UPDATE_DEALER_PAYMENT_FAILURE, error.response.data));
  },
  getSubscriptionPaymentList({ commit }, filter) {
    commit(GET_SUBSCRIPTION_PAYMENT_LIST_BEGIN);
    return payment.getSubscriptionPaymentList(filter)
      .then((response) => commit(GET_SUBSCRIPTION_PAYMENT_LIST_SUCCESS, response.data))
      .catch((error) => commit(GET_SUBSCRIPTION_PAYMENT_LIST_FAILURE, error.response.data));
  },
  getRefundPaymentList({ commit }, filter) {
    commit(GET_REFUND_PAYMENT_LIST_BEGIN);
    return payment.getRefundPaymentList(filter)
      .then((response) => commit(GET_REFUND_PAYMENT_LIST_SUCCESS, response.data))
      .catch((error) => commit(GET_REFUND_PAYMENT_LIST_FAILURE, error.response.data));
  },
  createPayment({ commit }, data) {
    commit(CREATE_PAYMENT_BEGIN);
    return payment.createPayment(data)
      .then((response) => commit(CREATE_PAYMENT_SUCCESS, response.data))
      .catch((error) => commit(CREATE_PAYMENT_FAILURE, error.response.data));
  },
  checkPayment({ commit }, id) {
    commit(CHECK_PAYMENT_BEGIN);
    return payment.checkPayment(id)
      .then((response) => commit(CHECK_PAYMENT_SUCCESS, response.data))
      .catch((error) => commit(CHECK_PAYMENT_FAILURE, error.response.data));
  },
  resetPayment({ commit }) {
    commit(RESET_PAYMENT_ID);
  },
};

const mutations = {
  [GET_PAYMENTS_BEGIN](state) {
    state.paymentListError = false;
  },
  [GET_PAYMENTS_SUCCESS](state, data) {
    state.paymentList = data;
    state.paymentListError = false;
  },
  [GET_PAYMENTS_FAILURE](state) {
    state.paymentListError = true;
  },
  [GET_PROVIDER_PAYMENT_LIST_BEGIN](state) {
    state.providerPaymentError = false;
  },
  [GET_PROVIDER_PAYMENT_LIST_SUCCESS](state, data) {
    state.providerPaymentList = data;
    state.providerPaymentError = false;
  },
  [GET_PROVIDER_PAYMENT_LIST_FAILURE](state, data) {
    state.providerPaymentError = data;
  },
  [GET_DEALER_PAYMENT_LIST_BEGIN](state) {
    state.dealerPaymentError = false;
  },
  [GET_DEALER_PAYMENT_LIST_SUCCESS](state, data) {
    state.dealerPaymentList = data;
    state.dealerPaymentError = false;
  },
  [GET_DEALER_PAYMENT_LIST_FAILURE](state, data) {
    state.dealerPaymentError = data;
  },
  [CREATE_DEALER_PAYMENT_BEGIN](state) {
    state.createDealerPaymentError = false;
  },
  [CREATE_DEALER_PAYMENT_SUCCESS](state) {
    state.createDealerPaymentError = false;
  },
  [CREATE_DEALER_PAYMENT_FAILURE](state, data) {
    state.createDealerPaymentError = data;
  },
  [UPDATE_DEALER_PAYMENT_BEGIN](state) {
    state.updateDealerPaymentError = false;
  },
  [UPDATE_DEALER_PAYMENT_SUCCESS](state) {
    state.updateDealerPaymentError = false;
  },
  [UPDATE_DEALER_PAYMENT_FAILURE](state, data) {
    state.updateDealerPaymentError = data;
  },
  [GET_SUBSCRIPTION_PAYMENT_LIST_BEGIN](state) {
    state.subscriptionPaymentError = false;
  },
  [GET_SUBSCRIPTION_PAYMENT_LIST_SUCCESS](state, data) {
    state.subscriptionPaymentList = data;
    state.subscriptionPaymentError = false;
  },
  [GET_SUBSCRIPTION_PAYMENT_LIST_FAILURE](state, data) {
    state.subscriptionPaymentError = data;
  },
  [GET_REFUND_PAYMENT_LIST_BEGIN](state) {
    state.refundPaymentError = false;
  },
  [GET_REFUND_PAYMENT_LIST_SUCCESS](state, data) {
    state.refundPaymentList = data;
    state.refundPaymentError = false;
  },
  [GET_REFUND_PAYMENT_LIST_FAILURE](state, data) {
    state.refundPaymentError = data;
  },
  [CREATE_PAYMENT_BEGIN](state) {
    state.error = false;
  },
  [CREATE_PAYMENT_SUCCESS](state, data) {
    state.paymentData = data;
    localStorage.setItem('paymentId', data.id);
    state.paymentId = data.id;
    state.error = false;
  },
  [CREATE_PAYMENT_FAILURE](state, data) {
    state.error = data;
  },
  [CHECK_PAYMENT_BEGIN](state) {
    state.error = false;
  },
  [CHECK_PAYMENT_SUCCESS](state, data) {
    state.paymentData = data;
    state.error = false;
  },
  [CHECK_PAYMENT_FAILURE](state) {
    state.error = true;
  },
  [RESET_PAYMENT_ID](state) {
    localStorage.removeItem('paymentId');
    state.paymentData = '';
    state.paymentId = '';
  },
};

export default {
  namespaced: true,
  state: initialState,
  getters,
  actions,
  mutations,
};
